module.exports = __webpack_public_path__ + "img/no-favorites.2c50c23c.svg";